// Import app modules.
document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("auto-resize", $684fd775931cf767$var$AutoResizeDirective);
});
/**
* I auto-resize the textarea as the user types.
*/ function $684fd775931cf767$var$AutoResizeDirective(element, metadata, framework) {
    var lineCount = 1;
    var timer = null;
    var delay = 250;
    init();
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I setup the directive.
	*/ function init() {
        framework.cleanup(destroy);
        element.addEventListener("input", handleInput);
        resizeTextarea();
    }
    /**
	* I tear down the directive.
	*/ function destroy() {
        element.removeEventListener("input", handleInput);
        clearTimeout(timer);
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I handle the input event.
	*/ function handleInput(event) {
        clearTimeout(timer);
        timer = setTimeout(resizeTextarea, delay);
    }
    /**
	* I apply the debounced resizing of the textarea.
	*/ function resizeTextarea() {
        var lineBreaks = element.value.match(/\r\n?|\n/g);
        var newLineCount = lineBreaks ? lineBreaks.length + 1 : 1;
        // Only attempt resize if the line-count has changed.
        if (lineCount === newLineCount) return;
        lineCount = newLineCount;
        // Setting the height to 0 will get the browser to resize the textarea to it's
        // smallest possible dimensions (taking into account the min-height property).
        element.style.height = 0;
        // Then, reading the scrollHeight will force a repaint and will give us the actual
        // height of the content, which we then store back into the element. Thankfully,
        // this control-flow doesn't appear to cause any UI flashing on the desktop.
        // --
        // Note: adding a few pixels because the scrollHeight doesn't seem into include
        // the border-width; but the box-sizing settings will include border-width when
        // adjusting the height. As such, we have to add the border-width to the new
        // height assignment.
        element.style.height = `${element.scrollHeight + 2}px`;
    }
}


document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("meta-enter-submit", $ea22c87a6fd0f9f3$var$MetaEnterSubmitDirective);
});
/**
* I allow a form to be submitted with the meta-enter keyboard combo.
*/ function $ea22c87a6fd0f9f3$var$MetaEnterSubmitDirective(element, metadata, framework) {
    init();
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I setup the directive.
	*/ function init() {
        framework.cleanup(destroy);
        element.addEventListener("keydown", handleKeydown);
    }
    /**
	* I tear down the directive.
	*/ function destroy() {
        element.removeEventListener("keydown", handleKeydown);
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I handle the keydown event.
	*/ function handleKeydown(event) {
        if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            element.form.requestSubmit();
        }
    }
}


document.addEventListener("alpine:init", function setupAlpineBindings() {
    Alpine.directive("prevent-double-submit", $53230d1a9759c1c5$var$PreventDoubleSubmitDirective);
});
/**
* I prevent accidental double-form submissions.
*/ function $53230d1a9759c1c5$var$PreventDoubleSubmitDirective(element, metadata, framework) {
    var isSubmitting = false;
    window.addEventListener("pageshow", handlePageshow);
    element.addEventListener("submit", handleSubmit);
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I get the relevant submission buttons.
	*/ function getButtons() {
        return element.querySelectorAll("button[type='submit'], input[type='submit']");
    }
    /**
	* I handle the pageshow event which is triggered when the page is rendered due to
	* browser navigation. This puts the form back into a submittable state so that the
	* user can re-submit it.
	*/ function handlePageshow(event) {
        // If the page wasn't pulled from the bfcache (Back/Forward), then the controller
        // is already in a good state.
        if (!event.persisted) return;
        isSubmitting = false;
        for (var node of getButtons()){
            node.classList.remove("isDisabled");
            node.disabled = false;
        }
    }
    /**
	* I handle the submit event, disabling buttons to prevent double-submission.
	*/ function handleSubmit(event) {
        if (isSubmitting) {
            event.preventDefault();
            console.info("Double form-submission prevented (x-prevent-double-submit).");
            return;
        }
        isSubmitting = true;
        for (var node of getButtons()){
            // All buttons are safe to "visually disable" since the above logic will act
            // as the ultimate control flow. The button rendering is just a UX issue.
            node.classList.add("isDisabled");
            // Note: we can't disable buttons that have a "name" attribute otherwise the
            // button "value" may not get submitted back to the server.
            if (!node.hasAttribute("name")) node.disabled = true;
        }
    }
}



var $86bb4e461831ea19$exports = {};
var $1051a56647a5a5e6$exports = {};
window.pm14ud = {
    ErrorMessage: $1051a56647a5a5e6$var$ErrorMessage
};
function $1051a56647a5a5e6$var$ErrorMessage() {
    return {
        init: $init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function $init() {
        this.$el.focus();
        this.$refs.scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
}



$86bb4e461831ea19$exports = {
    "js": $1051a56647a5a5e6$exports,
    "less": {}
};


var $9c5a5af9d58ac867$exports = {};
var $a3075d2479a03af1$exports = {};
window.izm317 = {
    FlashMessage: $a3075d2479a03af1$var$FlashMessage
};
function $a3075d2479a03af1$var$FlashMessage() {
    return {
        init: init
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        // In order to make sure that the target page remains easily sharable; and, that
        // sharing the given URL doesn't constantly show the flash message; we're going to
        // remove the flash query-string parameter.
        var url = new URL(window.location.href);
        url.searchParams.delete("flash");
        url.searchParams.delete("flashData");
        window.history.replaceState({}, "", url);
        // Focus the flash message as well.
        this.$el.focus();
    }
}



$9c5a5af9d58ac867$exports = {
    "js": $a3075d2479a03af1$exports,
    "less": {}
};


var $7ec2972a5ceb401a$exports = {};

$7ec2972a5ceb401a$exports = {
    "less": {}
};


var $3eb47a8158ce7ea3$exports = {};
var $77e8cdefabc42a7e$exports = {};
window.vn9w7t = {
    SkipToMain: $77e8cdefabc42a7e$var$SkipToMain
};
function $77e8cdefabc42a7e$var$SkipToMain() {
    return {
        // Public properties.
        target: null,
        init: // Life-cycle methods.
        init,
        focusMain: // Public methods.
        focusMain
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        this.target = document.querySelector(this.$el.getAttribute("href"));
    }
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I programmatically focus the main content area.
	*/ function focusMain() {
        this.target.focus();
        this.target.scrollIntoView();
    }
}



$3eb47a8158ce7ea3$exports = {
    "js": $77e8cdefabc42a7e$exports,
    "less": {}
};


var $42dd7df5bbf20c44$exports = {};

$42dd7df5bbf20c44$exports = {
    "less": {}
};


var $b0667bc53dd7eee2$exports = {};
var $531c21de00e9e9b7$exports = {};
window.jy2g1b = {
    Toaster: $531c21de00e9e9b7$var$Toaster
};
function $531c21de00e9e9b7$var$Toaster() {
    var host = this.$el;
    return {
        // Public properties.
        items: [],
        previouslyActiveElement: null,
        // Life-cycle methods.
        init: init,
        addItem: // Public Methods.
        addItem,
        handleKeydown: handleKeydown,
        handleToast: handleToast,
        removeItem: removeItem,
        shiftFocus: shiftFocus,
        unshiftFocus: unshiftFocus
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
    // ...
    }
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I add a new item to the toast queue.
	*/ function addItem(message, isError = false) {
        this.items.unshift({
            uid: Date.now(),
            message: message,
            isError: isError
        });
        this.shiftFocus();
    }
    /**
	* I handle the keydown event when the dismiss button is focused.
	*/ function handleKeydown(event, index) {
        if (event.key === "Escape") {
            event.preventDefault();
            this.removeItem(index);
        }
    }
    /**
	* I add a new toast item based on the given event.
	*/ function handleToast(event) {
        this.addItem(event.detail.message, event.detail.isError);
    }
    /**
	* I remove the item at the given index.
	*/ function removeItem(index) {
        this.items.splice(index, 1);
        if (this.items.length) this.shiftFocus();
        else this.unshiftFocus();
    }
    /**
	* I shift the focus to the next most recent toast item.
	*/ function shiftFocus() {
        if (!this.previouslyActiveElement) this.previouslyActiveElement = document.activeElement || null;
        // Note: in Chrome (at least), there seems to be an issue where calling focus on
        // repeatedly-shown items doesn't always allow the focus to be transferred. So,
        // I'm using the next tick to give the browser a chance to chill out.
        this.$nextTick(()=>{
            host.querySelector(".item .dismiss")?.focus();
        });
    }
    /**
	* I shift the focus back to the previously active element what was in focus before the
	* toaster stole focus.
	*/ function unshiftFocus() {
        if (this.previouslyActiveElement) {
            this.previouslyActiveElement.focus();
            this.previouslyActiveElement = null;
        }
    }
}



$b0667bc53dd7eee2$exports = {
    "js": $531c21de00e9e9b7$exports,
    "less": {}
};


var $d6b63d3a792fc883$exports = {};


var $5431850fde21b4c6$exports = {};
window.r2mwmx = {
    ProseContent: $5431850fde21b4c6$var$ProseContent,
    WordTools: $5431850fde21b4c6$var$WordTools
};
function $5431850fde21b4c6$var$ProseContent(localStorageKey) {
    return {
        // Properties.
        storageKey: localStorageKey,
        init: // Life-Cycle Methods.
        init,
        loadContent: // Public Methods.
        loadContent,
        saveContent: saveContent
    };
    // ---
    // LIFE-CYCLE METHODS.
    // ---
    /**
	* I initialize the component.
	*/ function init() {
        this.loadContent();
    }
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I load any persisted poem from LocalStorage into the element.
	*/ function loadContent() {
        try {
            this.$el.value = localStorage.getItem(this.storageKey) || this.$el.dataset.defaultValue;
        } catch (error) {
            console.warn("Couldn't load poem from local storage.");
            console.error(error);
        }
    }
    /**
	* I persist the poem to the localStorage for future loads.
	*/ function saveContent() {
        try {
            localStorage.setItem(this.storageKey, this.$el.value);
        } catch (error) {
            console.warn("Couldn't persist poem to local storage.");
            console.error(error);
        }
    }
}
function $5431850fde21b4c6$var$WordTools() {
    return {
        handleBeforeResults: // Public methods.
        handleBeforeResults,
        handleRhyme: handleRhyme,
        handleSynonym: handleSynonym,
        loadDefinitions: // Private methods.
        loadDefinitions,
        loadRhymes: loadRhymes,
        loadSynonyms: loadSynonyms
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I inspect the beforeSwap event when rendering results to see if we need to override
	* the swap behavior. If there's no triggering event (ex, load trigger) or there's no
	* submitter (ex, .requestSubmit()), it means that the AJAX request was triggered
	* without a direct user interaction on the parent form. In that case, we don't want
	* the page to automatically scroll down to the form as that would be jarring.
	*/ function handleBeforeResults(event) {
        if (!event.detail.requestConfig.triggeringEvent?.submitter) event.detail.swapOverride = "innerHTML";
    }
    /**
	* I trigger a related searches for the given word.
	*/ function handleRhyme(event) {
        var word = event.detail.word;
        this.loadSynonyms(word);
        this.loadDefinitions(word);
    }
    /**
	* I trigger a related searches for the given word.
	*/ function handleSynonym(event) {
        var word = event.detail.word;
        this.loadRhymes(word);
        this.loadDefinitions(word);
    }
    // ---
    // PRIVATE METHODS.
    // ---
    /**
	* I submit a definition search for the given word.
	*/ function loadDefinitions(word) {
        var form = this.$refs.definitionForm;
        var input = form.elements.word;
        input.value = word;
        form.requestSubmit();
    }
    /**
	* I submit a rhyme search for the given word.
	*/ function loadRhymes(word) {
        var form = this.$refs.rhymeForm;
        var input = form.elements.word;
        input.value = word;
        form.requestSubmit();
    }
    /**
	* I submit a synonym search for the given word.
	*/ function loadSynonyms(word) {
        var form = this.$refs.synonymForm;
        var input = form.elements.word;
        input.value = word;
        form.requestSubmit();
    }
}



var $a30b0ee67f550c30$exports = {};
window.ht6w2p = {
    Rhymes: $a30b0ee67f550c30$var$Rhymes
};
function $a30b0ee67f550c30$var$Rhymes() {
    return {
        handleClick: handleClick
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I handle the button click and dispatch the corresponding word.
	*/ function handleClick(event) {
        this.$dispatch("app:word", {
            word: event.target.textContent
        });
    }
}




var $74dd028cd647cdc5$exports = {};
window.nq3j8v = {
    Synonyms: $74dd028cd647cdc5$var$Synonyms
};
function $74dd028cd647cdc5$var$Synonyms() {
    return {
        handleClick: handleClick
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I handle the button click and dispatch the corresponding word.
	*/ function handleClick(event) {
        this.$dispatch("app:word", {
            word: event.target.textContent
        });
    }
}



var $2f9af451328c88a7$exports = {};
window.kv4r2p = {
    AppShell: $2f9af451328c88a7$var$AppShell,
    Header: $2f9af451328c88a7$var$Header
};
function $2f9af451328c88a7$var$AppShell() {
    // Note: I'm leaving this component in because the [x-data] in the root ensures that
    // the rest of the page is alpine aware (otherwise, custom directives may not fire).
    return {};
}
function $2f9af451328c88a7$var$Header() {
    return {
        // Public properties.
        isNavOpen: false,
        toggleNav: // Public methods.
        toggleNav
    };
    // ---
    // PUBLIC METHODS.
    // ---
    /**
	* I toggle the static rendering of the nav menu.
	*/ function toggleNav() {
        this.isNavOpen = !this.isNavOpen;
    }
}





$d6b63d3a792fc883$exports = {
    "home": {
        "home": {
            "less": {}
        }
    },
    "playground": {
        "definitions": {
            "less": {}
        },
        "editor": {
            "js": $5431850fde21b4c6$exports,
            "less": {}
        },
        "rhymes": {
            "js": $a30b0ee67f550c30$exports,
            "less": {}
        },
        "syllables": {
            "less": {}
        },
        "synonyms": {
            "js": $74dd028cd647cdc5$exports,
            "less": {}
        }
    },
    "_shared": {
        "layout": {
            "default": {
                "js": $2f9af451328c88a7$exports,
                "less": {}
            }
        }
    },
    "legal": {
        "termsOfService": {
            "termsOfService": {
                "less": {}
            }
        },
        "privacyPolicy": {
            "privacyPolicy": {
                "less": {}
            }
        }
    }
};


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
// Disable injection of CSS for htmx indicator styles.
htmx.config.includeIndicatorStyles = false;
// Note: by starting Alpine after the DOM is ready, it should give any other deferred
// scripts time to load and register components before Alpine is bootstrapped.
document.addEventListener("DOMContentLoaded", (event)=>{
    Alpine.start();
});


//# sourceMappingURL=marketing.1b9b184b.js.map
